module.exports = __webpack_public_path__ + "img/generationyouth-banner.51d487b4.jpg";